import { render, staticRenderFns } from "./DashboardCollections.vue?vue&type=template&id=600a93b0&"
import script from "./DashboardCollections.vue?vue&type=script&lang=js&"
export * from "./DashboardCollections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports